import React, { Component } from "react";

import "./css/Header.css";

export default class Header extends Component {
  render() {
    return (
      <div className="header" style={this.props.style}>
        <div>
          <div className="snow" />

          <img
            draggable={false}
            alt="header"
            className="header-image"
            src={this.props.image}
            onLoad={this.props.handleImageLoad}
          />
          <div className="header-content">
            <div className="outfits">
              <p className="left">{this.props.text1}</p>
              <p className="right">{this.props.text2}</p>
            </div>

            <div className="releaseDate">
              <p className="middle">{this.props.text3}</p>

              <div
                className="scroll_down"
                onClick={() =>
                  this.props.refs.dman.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "start"
                  })
                }
              >
                <div className="arrowAnim">
                  <div className="arrowSliding">
                    <div className="arrow" />
                  </div>
                  <div className="arrowSliding delay1">
                    <div className="arrow" />
                  </div>
                  <div className="arrowSliding delay2">
                    <div className="arrow" />
                  </div>
                  <div className="arrowSliding delay3">
                    <div className="arrow" />
                  </div>
                </div>
                EXPLORE THE WINTER CONTENT
                <div className="arrowAnim">
                  <div className="arrowSliding">
                    <div className="arrow" />
                  </div>
                  <div className="arrowSliding delay1">
                    <div className="arrow" />
                  </div>
                  <div className="arrowSliding delay2">
                    <div className="arrow" />
                  </div>
                  <div className="arrowSliding delay3">
                    <div className="arrow" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
